/** The owned asset is square, so it belongs on a small summary card. */
export const SOCIAL_IMAGE = {
  url: "https://beancount.io/lgasset/logo.png",
  type: "image/png",
  width: "256",
  height: "256",
  alt: "Beancount.io logo",
  card: "summary",
} as const;
